import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

// Auth is now via httpOnly cookie set by the backend.
// Cookies flow automatically; we never read or write the token from JavaScript.
// withCredentials:true tells axios to include cookies on cross-origin requests.
export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 15_000
});

// Auto-redirect on 401 (cookie missing or expired).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // Avoid infinite loops on the login page itself
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    throw err;
  }
);
